import { render } from "./TeamArea.vue?vue&type=template&id=efd965b6"
import script from "./TeamArea.vue?vue&type=script&lang=js"
export * from "./TeamArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__